// extracted by mini-css-extract-plugin
export default {"role":"_21dRb"};